<template>
	<div class="status-grid">
		<div v-for="(item, index) in statusList" :key="item.label" class="status-item">
			<div>{{ index + 1 }}</div>
			<div class="label">{{ item.label }}</div>
			<el-progress
				style="flex: 1"
				:percentage="total ? (item.count / total) * 100 : 0"
				:stroke-width="8"
				:show-text="false"
				:color="item.color"></el-progress>
			<div class="count">{{ item.count }}万</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeaseStatusStatistics',
		props: {
			assetRentStats: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				statusList: [
					{ count: 10, label: '物业管理费', key: 'rentedCount' },
					{ count: 0.08, label: '租金', key: 'availableCount' },
					{ count: 0.08, label: '测试', key: 'renovatingCount' },
					{ count: 0.08, label: '垃圾处理费', key: 'reservedCount' },
					{ count: 0.08, label: '车位管理费', key: 'reservedCount' },
					{ count: 0.08, label: '责任', key: 'reservedCount' },
					{ count: 0.08, label: '水电费', key: 'reservedCount' },
				],
				total: 10,
				rentRate: '',
			};
		},
		watch: {
			assetRentStats: {
				handler(newVal) {
					if (!newVal) return;
					this.statusList.forEach(item => {
						item.count = newVal[item.key] || '0';
					});
					this.total = newVal.total;
					this.rentRate = newVal.rentRate;
				},
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		height: calc(100% - 38px);
		display: flex;
		flex-direction: column;
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}

	.title {
		font-weight: bold;
	}

	.status-grid {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		gap: 12px;
	}

	.status-item {
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
	}

	/* 文本 */
	.label {
		width: 80px;
		font-weight: 400;
		font-size: 14px;
		color: #000000;
	}

	/* 数字 */
	.count {
		width: 50px;
		text-align: right;
		font-weight: bold;
		font-size: 12px;
		color: #0f172a;
	}

	.percentage-row {
		margin-top: 13px;
		padding: 17px 24px 0px 24px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #3e3e3e;
	}

	.percentage-label {
		margin-left: 13px;
		margin-right: 8px;
	}

	.tip {
		flex: 1;
		cursor: help;
	}

	.percentage {
		font-weight: 600;
		font-size: 28px;
		color: #1c1c1c;
	}
</style>
